/** Watches the `dark` class on <html> to detect active dark mode. */

import { useSyncExternalStore } from "react";

function subscribe(callback: () => void) {
  const observer = new MutationObserver(callback);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["class"],
  });
  return () => observer.disconnect();
}

function getSnapshot() {
  return document.documentElement.classList.contains("dark");
}

export function useIsDarkMode(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
